import { useMemo } from 'react';

import { useAppSelector } from '../../app/store/hooks';

const useCheckNative = (): boolean => {
  // 1) Read from Redux
  const reduxValue = useAppSelector((state) => state.native.isAndroidNativeApp);
  // 2) Read from sessionStorage (only once per hook call)
  const storageValue = useMemo(() => {
    const stored = sessionStorage.getItem('isNativeApp');
    return stored === 'true';
  }, []);
  // 3) Return Redux if set, otherwise fallback to sessionStorage
  //    (you can invert priority if you prefer)
  return reduxValue || storageValue;
};

export default useCheckNative;
